import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Container } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { useAppSelector } from '../../store';

import ListTypeMobile from '../../components/ListTypeMobile/ListTypeMobile';
import SelectLocationsOnMobile from '../../components/SelectLocationsOnMobile/SelectLocationsOnMobile';
import SelectPrice from '../../components/SelectPrice/SelectPrice';

import { currencyFormat } from '../../utils/index';
import SelectList from '../../components/SelectList/SelectList';

export interface SelectedPopupType {
  actions: boolean;
  category: boolean;
  locations: boolean;
  price: boolean;
}

const locationTypeLanguage = {
  th: 'จังหวัด',
  en: 'Province',
  cn: '省',
};

const SearchMobile = () => {
  const stateMobile = useAppSelector((state) => state.mobile);
  const [selectedPopup, setSelectedPopup] = useState<SelectedPopupType>({
    actions: false,
    category: false,
    locations: false,
    price: false,
  });
  const [language, setLanguage] = useState<'th' | 'en' | 'cn'>('th');

  const handlePopupSelected = (key: string, value: boolean) => {
    setSelectedPopup((prevState) => ({ ...prevState, [key]: value }));
  };

  const showSelectValue = (list: 'actions' | 'category' | 'locations' | 'price') => {
    if (list === 'price' && stateMobile['price'].priceMin !== 0 && stateMobile['price'].priceMax !== 0) {
      return (
        <>{`${currencyFormat(stateMobile['price'].priceMin)} - ${currencyFormat(stateMobile['price'].priceMax)}`}</>
      );
    }
    if (stateMobile[list] && list === 'locations') {
      return <>{stateMobile[list].replace(`${locationTypeLanguage[language]} > `, '')}</>;
    }

    if (stateMobile[list] && list !== 'price') {
      return <>{stateMobile[list]}</>;
    }

    return <div className="text-slate-400">{list}</div>;
  };

  const onSubmitSearch = () => {
    const arrayLocations = stateMobile.locations.replace(`${locationTypeLanguage[language]} > `, '').trim().split('>');
    let resultLocation = '';
    arrayLocations.forEach((location) => {
      resultLocation += `/${location}`;
    });

    const goAction = stateMobile.actions ? stateMobile.actions : 'รวม';
    const goCategory = stateMobile.category ? stateMobile.category : 'อสังหา';
    const goPriceMin = stateMobile.price.priceMin !== 0 ? `?startPrice=${stateMobile.price.priceMin}` : '';
    const goPriceMax = stateMobile.price.priceMax !== 0 ? `&endPrice=${stateMobile.price.priceMax}` : '';

    let replaceUrl = `${process.env.REACT_APP_HOME_URL || 'https://9asset.com'}`;
    replaceUrl += `/${goAction}/${goCategory}${resultLocation}${goPriceMin}${goPriceMax}`;

    window.location.replace(replaceUrl);
  };

  return (
    <>
      <Container className="relative">
        <div className="flex justify-end">
          <IconButton>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="relative">
          <div className="absolute w-full">{/* <Search /> */}</div>
          <SelectList
            label={'Language'}
            value={language}
            setValue={setLanguage}
            list={[
              {
                value: 'th',
                name: 'th',
              },
              {
                value: 'en',
                name: 'en',
              },
              {
                value: 'cn',
                name: 'cn',
              },
            ]}
          />
        </div>
        <div className="mt-16">
          {(['actions', 'category', 'locations', 'price'] as const).map((list) => (
            <div key={list}>
              <div
                className="border px-4 rounded flex justify-between items-center my-2 bg-[#f8e8de] border-[#f8e8de]"
                onClick={() => {
                  setSelectedPopup((prevState) => ({ ...prevState, [list]: true }));
                }}>
                {showSelectValue(list)}
                <IconButton>
                  <KeyboardArrowDownIcon />
                </IconButton>
              </div>
              {list === 'actions' && selectedPopup.actions && (
                <ListTypeMobile listType={list} handlePopupSelected={handlePopupSelected} language={language} />
              )}
              {list === 'category' && selectedPopup.category && (
                <ListTypeMobile listType={list} handlePopupSelected={handlePopupSelected} language={language} />
              )}
              {list === 'locations' && selectedPopup.locations && (
                <SelectLocationsOnMobile
                  open={selectedPopup[list]}
                  listType={list}
                  handlePopupSelected={handlePopupSelected}
                  language={language}
                />
              )}
              {list === 'price' && selectedPopup.price && (
                <SelectPrice
                  listType={list}
                  open={selectedPopup[list]}
                  handlePopupSelected={handlePopupSelected}
                  language={language}
                />
              )}
            </div>
          ))}
        </div>
        <button
          className="border rounded flex justify-center items-center w-full py-2 mt-6 bg-[#f4762a] text-white"
          onClick={() => onSubmitSearch()}>
          ค้นหา
        </button>
      </Container>
    </>
  );
};

export default SearchMobile;
